/**
 * WordPress dependencies
 */
export * from '@wordpress/core-data';
